import { SplideTrack, Splide, SplideSlide } from "@splidejs/react-splide";
import { React, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchBanners } from "../banners/cl_Banners";
import useFilterGamesByType from "../../services/helper/filterGamesByType";
// import { setHomePopUp } from "../signIn/cl_SignInSlice";

const FooterBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterByGameType = useFilterGamesByType();
  const { superBannersData } = useSelector((state) => state.banners);
  const token = localStorage.getItem("gk");

  useEffect(() => {
    dispatch(fetchBanners());
  }, [dispatch]);

  const handleBannerClick = (e, banner) => {
    e.preventDefault();
    // dispatch(setHomePopUp(true));
    const categoryName = banner.banner_name;

    if (banner.banner_link.startsWith("/games/")) {
      const gameType = banner.banner_link.split("/games/")[1];
      const filteredGames = filterByGameType(gameType);
      const gamesList =
        filteredGames[0]?.game?.length > 0 ? filteredGames[0]?.game : [];

      if (!token) {
        navigate("/signin");
        return;
      }

      navigate(`/games/${gameType}`, {
        state: {
          gamesList,
          title: categoryName,
          game_type: gameType,
        },
      });
    } else {
      navigate(banner.banner_link || "/");
    }
  };

  return (
    <>
      {Array.isArray(superBannersData) && superBannersData.length > 0
        ? superBannersData
            .filter(
              (bannerGroup) =>
                bannerGroup.is_active &&
                bannerGroup.master_typeid === 13 &&
                (token ? bannerGroup.after_login : bannerGroup.before_login)
            )
            .map((bannerGroup, index) => (
              <div className="SB-superBanner SB-gameBanner" key={index}>
                    <Splide
                      className="SB-splide-superBanner"
                      hasTrack={false}
                      options={{
                        type: "loop",
                        pagination: true,
                        autoplay: true,
                        autoWidth: true,
                        arrows: false,
                        focus: "center",
                        lazyLoad: "sequential",
                      }}
                    >
                      <SplideTrack>
                        <SplideSlide>
                          <div
                            onClick={(e) => handleBannerClick(e, bannerGroup)}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={bannerGroup.imagepath}
                              alt={bannerGroup.banner_name}
                            />
                          </div>
                        </SplideSlide>
                      </SplideTrack>
                    </Splide>
                  </div>
            ))
        : null}
    </>
  );
};

export default FooterBanner;
